import { useLanguage } from '../../i18n/LanguageContext';

const MovingMessage = () => {
  const { t, dir } = useLanguage();

  return (
    <div className="bg-emerald-600 text-white overflow-hidden py-2 z-10" dir={dir}>
      <div className="whitespace-nowrap animate-slideIn lg:animate-none text-center">
        <span className="text-sm font-semibold">
          {t('movingMsg')}
        </span>
      </div>
    </div>
  );
};

export default MovingMessage;
